<template>
  <ul
    class="v1-recommendationItinerariesList"
    :class="'-' + context"
    id="v1-recommendationItinerariesList"
  >
    <li class="v1-recommendationItinerariesList__item" v-for="post in posts" :key="post.id">
      <a
        class="v1-recommendationItinerariesList__link"
        :href="'/' + pageLang + '/' + pageCountry + post.url"
      >
        <figure class="v1-recommendationItinerariesList__figure">
          <img class="v1-recommendationItinerariesList__image" :src="post.img" alt="" />
          <img
            class="v1-recommendationItinerariesList__mask"
            :src="`/japan-travel-planner/common/img/map/map_itinerary${zeroFill(post.id)}.svg`"
            alt=""
            aria-hidden="true"
          />
        </figure>
        <div class="v1-recommendationItinerariesList__body">
          <h3 class="v1-recommendationItinerariesList__title" v-html="$sanitize(post.title)"></h3>
          <p class="v1-recommendationItinerariesList__place" v-html="$sanitize(post.label)"></p>
          <svg class="v1-recommendationItinerariesList__icon" role="img" focusable="false">
            <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#arrow-link-right"></use>
          </svg>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'v1ItineraryListItem',
  props: {
    posts: {
      type: Array,
      required: true,
      default: () => [],
    },
    pageLang: {
      type: String,
      required: true,
    },
    pageCountry: {
      type: String,
      required: true,
    },
    context: {
      type: String,
      required: false,
    },
  },
  methods: {
    zeroFill(num) {
      return String(num).padStart(2, '0');
    },
  },
};
</script>
